var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      attrs: {
        fixed: "",
        permanent: "",
        app: "",
        "disable-resize-watcher": "",
        clipped: _vm.navDrawer.clipped,
        floating: _vm.navDrawer.floating,
      },
      scopedSlots: _vm._u([
        {
          key: "prepend",
          fn: function () {
            return [
              _c(
                "v-card",
                { attrs: { flat: "", link: "", to: { name: "page-index" } } },
                [
                  _c("v-card-title", { staticClass: "title py-2" }, [
                    _vm._v(" " + _vm._s(_vm.$t("app.name")) + " "),
                  ]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "append",
          fn: function () {
            return [
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _c("v-divider"),
                  false
                    ? _c(
                        "v-list-item",
                        { staticClass: "py-2" },
                        [_c("LanguagePopover")],
                        1
                      )
                    : _vm._e(),
                  _c("v-divider"),
                  _c(
                    "v-list-item",
                    {
                      on: {
                        click: function ($event) {
                          _vm.uiGeneral.darkTheme = !_vm.uiGeneral.darkTheme
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-theme-light-dark")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(" Светлая/Темная тема "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.logOut } },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-logout")])],
                        1
                      ),
                      _c("v-list-item-title", [_vm._v("Выход")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.navDrawer.opened,
        callback: function ($$v) {
          _vm.$set(_vm.navDrawer, "opened", $$v)
        },
        expression: "navDrawer.opened",
      },
    },
    [
      _c("v-divider"),
      _vm.$permissionsHandler(["READ_EVENT"])
        ? _c(
            "v-list",
            { attrs: { dense: "" } },
            [
              _vm.eventCategories && _vm.eventCategories.length
                ? _c(
                    "v-list-group",
                    {
                      attrs: { dense: "", "no-action": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "pl-0",
                                    attrs: {
                                      to: { name: "page-events" },
                                      dense: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v("События"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        837461872
                      ),
                    },
                    [
                      _vm._l(_vm.eventList, function (categoryItem) {
                        return _c(
                          "v-list-item",
                          {
                            key: categoryItem.id,
                            staticClass: "pl-8",
                            attrs: {
                              dense: "",
                              to:
                                categoryItem.slug !== "events"
                                  ? {
                                      name: "page-events-by-category",
                                      params: {
                                        categorySlug: categoryItem.slug,
                                      },
                                    }
                                  : {
                                      name: "page-events",
                                    },
                              link: "",
                            },
                          },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(
                                    " " + _vm._s(categoryItem.title) + " "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _c("v-divider"),
                      _vm.$permissionsHandler(["READ_EVENTCATEGORY"])
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-5",
                              attrs: {
                                to: { name: "page-categories" },
                                link: "",
                                dense: "",
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Категории событий"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$permissionsHandler(["READ_EVENTATTRIBUTEKEY"])
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-5",
                              attrs: {
                                to: { name: "page-attributes" },
                                link: "",
                                dense: "",
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [_c("v-list-item-title", [_vm._v("Атрибуты")])],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("v-divider"),
      _c(
        "v-list",
        { attrs: { dense: "" } },
        [
          _vm._l(_vm.navItems, function (navItem, navItemIndex) {
            return [
              !navItem.children
                ? _c(
                    "v-list-item",
                    {
                      key: `${navItemIndex}-${navItemIndex}`,
                      class:
                        navItem.to.name === _vm.$route.name &&
                        !navItem.isDivider
                          ? "v-list-item--active"
                          : "",
                      attrs: {
                        dense: navItem.isDivider,
                        link: !navItem.isDivider,
                        ripple: navItem.to.name !== _vm.$route.name,
                        to:
                          navItem.to.name === _vm.$route.name ||
                          navItem.isDivider
                            ? null
                            : navItem.to || null,
                      },
                    },
                    [
                      navItem.isDivider
                        ? _c("v-divider")
                        : _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", {
                                domProps: { textContent: _vm._s(navItem.text) },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  )
                : _c(
                    "v-list-group",
                    {
                      key: `${navItemIndex}-${navItemIndex}`,
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "pl-0",
                                    attrs: {
                                      to: { name: `page-${navItem.key}` },
                                      dense: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", {
                                          domProps: {
                                            textContent: _vm._s(navItem.text),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    _vm._l(navItem.children, function (childItem) {
                      return _c(
                        "v-list-item",
                        {
                          key: childItem.id,
                          staticClass: "pl-8",
                          class:
                            childItem.to.name === _vm.$route.name &&
                            !childItem.isDivider
                              ? "v-list-item--active"
                              : "",
                          attrs: {
                            dense: "",
                            link: !childItem.isDivider,
                            ripple: childItem.to.name !== _vm.$route.name,
                            to:
                              childItem.to.name === _vm.$route.name ||
                              childItem.isDivider
                                ? null
                                : childItem.to || null,
                          },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", {
                                domProps: {
                                  textContent: _vm._s(childItem.text),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }